// extracted by mini-css-extract-plugin
export default {"Box_0":"BlankState-module__Box_0--AmMgB","Box_1":"BlankState-module__Box_1--AjzUe","Box_2":"BlankState-module__Box_2--jdCHM","Box_3":"BlankState-module__Box_3--cn1nb"};